import { createStyles, makeStyles } from '@material-ui/core/styles';
import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      listStyleType: 'none',
      display: 'flex',
      marginBottom: SMALL_MARGIN,
      position: 'relative',
      '&:not(:last-child)': {
        '& $circle::after': {
          content: '""',
          width: 3,
          background: colorsPalette.violetAnalyticsCard,
          height: 'calc(100% - 20px)',
          position: 'absolute',
          display: 'block',
          top: 34,
          left: 14,
          zIndex: 2,
          borderRadius: 3,
        },
      },
      '&.active $circle': {
        background: colorsPalette.green,
      },
      '&.active.nextActive $circle::after': {
        background: colorsPalette.green,
      },
      '&:last-child': {
        marginBottom: 0,
      },
    },
    title: {
      fontSize: 18,
      lineHeight: 1.5,
      color: colorsPalette.gray,
      cursor: 'pointer',
    },
    circle: {
      width: 30,
      height: 30,
      minWidth: 30,
      borderRadius: '50%',
      background: colorsPalette.violetAnalyticsCard,
      marginRight: MIDDLE_MARGIN,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    circleIcon: {
      width: 14,
      height: 14,
    },
  }),
);

export default useStyles;
